import React from 'react';
import { Search } from 'lucide-react';

import { cn } from '~/lib/utils';

import { SEARCH_BAR_STYLES } from '../constants';

interface SearchIconProps {
  isFocused: boolean;
  disabled?: boolean;
  className?: string;
}

export const SearchIcon: React.FC<SearchIconProps> = ({
  isFocused,
  disabled = false,
  className
}) => {
  return (
    <div className="absolute left-4 top-1/2 transform -translate-y-1/2 flex items-center justify-center">
      <Search
        className={cn(
          SEARCH_BAR_STYLES.SEARCH_ICON,
          isFocused
            ? SEARCH_BAR_STYLES.SEARCH_ICON_FOCUSED
            : SEARCH_BAR_STYLES.SEARCH_ICON_DEFAULT,
          disabled && SEARCH_BAR_STYLES.SEARCH_ICON_DISABLED,
          className
        )}
      />
    </div>
  );
};
